import React from "react";
import { servicesData, industriesData } from "../data/servicesData";
import "./ServicesStyle.css";

function Services() {
  return (
    <div className="services-container">
      <h1>What we do</h1>
      <p className="intro">
    We provide innovative, technology-driven solutions across multiple domains and industries — 
    helping enterprises accelerate digital transformation, automate processes, and achieve measurable outcomes.
  </p>

      {/* Services Section */}
      <div className="services-grid">
        {servicesData.map((service) => (
          <div key={service.id} className="service-card">
           {/*  <img src={service.image} alt={service.title} className="service-image" /> */}
            <h3>{service.title}</h3>
            {service.description}
          </div>
        ))}
      </div>

      {/* Industries Section */}
<section className="industries-section">
  <h2>Industries We Serve</h2>
  <div className="industries-grid">
    {industriesData.map((industry) => (
      <div key={industry.id} className="industry-card">
        {/*  <img src={industry.image} alt={industry.name} className="industry-image" />*/}
        <h4>{industry.name}</h4>
       {industry.description}
      </div>
    ))}
  </div>
</section>


    </div>
  );
}

export default Services;
